module.exports = __webpack_public_path__ + "static/media/play_stream_img.922f3dee.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/play_stream_img.svg
// module id = 659
// module chunks = 7